module.exports = __webpack_public_path__ + "static/img/home-img-1.4734358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-img-1.png
// module id = dEM+
// module chunks = 0